import type { InternalAxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';
import axios from 'axios';

const api = axios.create({
  baseURL: '/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Add auth token if available
    const authStorage = localStorage.getItem('auth-storage');
    let token: string | null = null;
    if (authStorage) {
      try {
        token = JSON.parse(authStorage).state?.token ?? null;
      } catch {
        token = null;
      }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => Promise.reject(error),
);

// Response interceptor
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Handle unauthorized
      localStorage.removeItem('auth-storage');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export const weatherApi = {
  getCurrentWeather: (lat: number, lon: number) =>
    api.get('/weather/current', { params: { lat, lon } }),

  getForecast: (lat: number, lon: number, days: number = 7) =>
    api.get('/weather/forecast', { params: { lat, lon, days } }),

  getAirQuality: (lat: number, lon: number) =>
    api.get('/weather/air-quality', { params: { lat, lon } }),
};

export const locationApi = {
  getAll: () => api.get('/locations'),
  
  add: (location: { name: string; latitude: number; longitude: number; is_favorite?: boolean }) =>
    api.post('/locations', location),
  
  delete: (id: string) => api.delete(`/locations/${id}`),
};

export default api;
